/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { RedlineLayerConfiguration } from '../../../components/redline/state/redline.model';
import { SafeHtml } from '@angular/platform-browser';
import { Select } from '@ngxs/store';
import { AppConfigState } from '../../../core/state/appConfig/app-config.state';
import { filter, pluck, tap } from 'rxjs/operators';
import { LoggerService } from '../../shared/services/logger.service';
import { PointIconStyle } from '../../../types';

@Component({
    selector: 'dash-gis-redline-icon',
    templateUrl: './redline-icon.component.html',
    styleUrls: ['./redline-icon.component.scss'],
})
export class RedlineIconComponent implements OnInit {
    @Input() public redlineClassName: string;
    @Input() public redlineConfig: RedlineLayerConfiguration;

    @Select(AppConfigState.legendIcons) private legendIcons$;

    constructor(private logger: LoggerService) {}

    ngOnInit() {}

    getLinePoints(width: number, height: number) {
        return [4, height - 1, (width - 1) / 2, 0, (width * 2) / 3, height - 1, width - 2, 0];
    }

    get iconDimensions$() {
        return this.legendIcons$.pipe(filter((b) => !!b));
    }

    get classConfig() {
        return this.redlineConfig.classes[this.redlineClassName];
    }
}
